import moment from 'moment';
moment.updateLocale('std', {
	week: {
		dow: 0
	}
});

export const _std = () => {
	const dayLowerCase = 'day';
	const weekLowerCase = 'week';
	const monthLowerCase = 'month';
	const qtrLowerCase = 'quarter';
	const yearLowerCase = 'year';
	moment.locale('std');
	const getLastXWkRange = (x, forShrink) => {
		if (forShrink) {
			let start = moment().clone().subtract(x, weekLowerCase).startOf(weekLowerCase);
			let end = moment().clone().subtract(1, weekLowerCase).endOf(weekLowerCase);
			return [start, end];
		}

		return [-x, -1];
	};

	const getLastXMonthRange = (x, forShrink) => {
		if (forShrink) {
			let start = moment().clone().subtract(x, monthLowerCase).startOf(monthLowerCase);
			let end = moment().clone().subtract(1, monthLowerCase).endOf(monthLowerCase);
			return [start, end];
		}
		return [-x, -1];
	};

	const getLastXQtrRange = (x, forShrink) => {
		if (forShrink) {
			let start = moment().clone().subtract(x, qtrLowerCase).startOf(qtrLowerCase);
			let end = moment().clone().subtract(1, qtrLowerCase).endOf(qtrLowerCase);
			return [start, end];
		}

		return [-x, -1];
	};

	const getLastYrRange = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().subtract(1, yearLowerCase).startOf(yearLowerCase);
			let end = moment().clone().subtract(1, yearLowerCase).endOf(yearLowerCase);
			return [start, end];
		}
		return [-1, -1];
	};

	const getWkToDate = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().startOf(weekLowerCase);
			let end = moment().clone().subtract(1, dayLowerCase);
			return [start, end];
		}
		return [0, 0];
	};

	const getMonthToDate = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().startOf(monthLowerCase);
			let end = moment().clone().subtract(1, dayLowerCase);
			return [start, end];
		}
		return [0, 0];
		// return ['1 months'];
	};

	const getQtrToDate = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().startOf(qtrLowerCase);
			let end = moment().clone().subtract(1, dayLowerCase);
			return [start, end];
		}
		return [0, 0];
	};

	const getYrToDate = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().startOf(yearLowerCase);
			let end = moment().clone().subtract(1, dayLowerCase);
			return [start, end];
		}
		return [0, 0];
	};

	const yesterday = (forShrink) => {
		if (forShrink) {
			let start = moment().clone().subtract(1, dayLowerCase);
			let end = moment().clone().subtract(1, dayLowerCase);
			return [start, end];
		}
		return [-1, -1];
	};

	return {
		getLastXWkRange,
		getWkToDate,
		getMonthToDate,
		getLastXMonthRange,
		getLastXQtrRange,
		getQtrToDate,
		getLastYrRange,
		getYrToDate,
		yesterday
	};
};
